<template>
	<button 
		class="btn btn-success"
		@click="finalizeUnit()">
		<i class="fas mr-2 fa-check"></i>
		Finalizar Unidade
	</button>
</template>

<script>
	export default {
		data(){
			return {
				request: {
					'quantidade_finalizada': 1
				},
				available: true
			}
		},
		methods: {
			finalizeUnit(){
				var config = {
					position: 'bottom-right',
				};
				axios.put(this.$url+'/api/adm/itens/finalizar-unidade/'+this.$route.params.id, (this.request))
	            .then(response => {
	            	this.$bshMessage.show(response.data.message, response.data.type, config)
	            	this.$emit('reload');
	            })
	            .catch(error => {
	            	this.$bshMessage.show(error.response.data.message, 'error')
	            });
			},
		}
	}
</script>